import { CANCELLATION_FEE_TABS, BOOKING_FEE_TABS, LANGUAGE_FEE_TABS } from "types/shared"
import { ISettingsContext, ISettingsState } from "./SettingsProviderTypes";

export const SETTINGS_INITIAL_CONTEXT: ISettingsContext = {
  languageSettings: {
    currentTab: LANGUAGE_FEE_TABS.GEORGIA,
    handleTabChange: () => {}
  },
  scheduleInterval: "",
  commission: null,
  cancelCommissions: [],
  cancelCommissionsHistory: [],
  commissionTabType: BOOKING_FEE_TABS.PERCENT,
  cancelCommissionsTabType: CANCELLATION_FEE_TABS.PERCENT,
  handleChangeScheduleIntervalSubmit: () => {},
  handleChangeLaundryCommissionSubmit: () => {},
  handleChangeCancelCommission: () => {},
  handleChangeCancelCommissionsSubmit: () => {},
  handleChangeCommissionTab: () => {},
  handleChangeCancelCommissionsTab: () => {},
  updateCancelCommissionsHistory: () => {},
  changeLaundryScheduleIntervalLoading: false,
  changeLaundryCommissionLoading: false,
  changeLaundryCancelCommissionsLoading: false
}

export const SETTINGS_INITIAL_STATE: ISettingsState = {
  languageSettings: {
    currentTab: LANGUAGE_FEE_TABS.GEORGIA,
    handleTabChange: () => {}
  },
  scheduleInterval: "",
  commission: null,
  cancelCommissions: [],
  cancelCommissionsHistory: [],
  commissionTabType: BOOKING_FEE_TABS.PERCENT,
  cancelCommissionsTabType: CANCELLATION_FEE_TABS.PERCENT
}